<div class="overlayDiv" *ngIf="isUIVisible">
  <div class="overlayInner">
  </div>
  <div class="videoPlayerDiv">
    <div class="mainDivContent">
      <div class="iconDiv" (click)="showVideo()">
        <i class="fas fa-times" style="font-size: 1rem;"></i>
      </div>
      <iframe style="width: 60vw; height: 100%;" src="https://www.youtube.com/embed/UGnOE_EMw-E"
              title="React Full Course - Next.js 14 Admin Dashboard with Tailwind CSS" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
    </div>
  </div>
</div>
<div class="about-us">

  <div class="content-page">

    <h2 class="mat-display-2">über uns</h2>
    <p>
      Wir gestalten Erwachsenbildung für eine plurale Stadtgesellschaft. In uns
      bündeln sich die Weiterbildungsidee, -bedarfe und -visionen von 60
      Migrant*innenorganisationen. Wir verstehen Bildungsprozesse nicht als
      fertige Struktur. Vielmehr ist die Dynamik dieser so angelegt, dass
      Lehrende und Lernende in einer Beziehung des miteinander und voneinander
      Lernens stehen. Wir versuchen in unserer täglichen Arbeit dem gerecht zu
      werden, indem wir den (Lern-)Erfahrungen genauso wie Emotionen aller am
      Lernprozess Beteiligten Raum geben. Wir sind davon überzeugt, dass
      kreatives Lernen hier einen Schlüsselrolle einnimmt, deshalb fördern wir
      kreative Lernmethoden und -prozesse.
    </p>
    <p>
      Das Bildungswerk Vielfalt ist anerkannt nach dem NRW Weiterbildungsgesetz.
      Trägerverein ist der Verbund sozial-kultureller Migrantenvereine in
      Dortmund e. V.
    </p>
    <p>
      Unsere Schwerpunkte in der Erwachsenenbildung sind Sprachbildung,
      Gesundheitsbildung, digitale, kulturelle sowie politische Bildung. Es gibt
      spezielle Angebote für Frauen und/oder Senior*innen. Seit einigen Jahren
      haben wir einmal jährlich einen Vorbereitungskurs auf die
      Ausbildereignungsprüfung für ethnische Unternehmer*innen.
    </p>
    <div>

      <div>
        Seit April 2024 wird unsere Arbeit durch einen Expert*innenbeirat fachkundig unterstützt. Zum Beitrat gehören:
      </div>
      <ul>
        <li><strong>Vedat Akkaya</strong>, Vorstandsvorsitzender VMDO e. V.</li>
        <li><strong>Levent Arslan</strong>, Direktor Dietrich-Keunig-Haus</li>
        <li><strong>Dr. Iuditha Balint</strong>, Direktorin Fritz-Hüser-Institut</li>
        <li><strong>Eva Busch</strong>, Kuratorin/stellvertretende Direktion Kunstmuseum Bochum</li>
        <li><strong>Thierry Monthé</strong>, Geschäftsführer Kaeyros Analytics</li>
        <li><strong>Julia Wissert</strong>, Intendantin Schauspiel Dortmund</li>
        <li><strong>Ümithan Yağmur</strong>, Vorstand Forum Jugend (Mitgliedsverein des VMDO e. V.)</li>
      </ul>
    </div>
    <p>
      Mit den Migrant*innenorganisationen aus unserer Träger- und
      Netzwerkstruktur arbeiten wir eng zusammen. Hier finden wir Teilnehmende,
      aber noch mehr sind es die Expert*innen aus den Netzwerken, die die Arbeit
      und Angebote des Bildungswerk Vielfalt zukunftsfähig machen. Um diese
      (bisher) ungesehenen Expert*innen und deren Wissen sichtbar zu machen,
      haben wir 2021 das 0 + 1 Festival ins Leben gerufen:
      <a href="https://www.nullpluseinsfestival.de" target="_blank">www.nullpluseinsfestival.de</a>
    </p>
    <p>
      Mit vielen Kulturinstitutionen (z. B. Schauspiel Dortmund, Dortmunder U,
      Dietrich Keuning Haus, Literaturhaus etc.) der Stadt besteht seit viel
      Jahren eine enge Kooperation, die wir stetig weiterentwickeln.
    </p>
    <p>
      Was wir aktuell tun, ist, eigene Wege im Umgang mit Diversität und
      Digitalität zu erproben, um einen aktiven Beitrag für Chancengerechtigkeit
      und Teilhabe zu leisten, damit unsere Angebote für persönliche,
      berufliche, aber auch politische und kulturelle Weiterbildung wirkliche
      Angebote für eine plurale Stadtgesellschaft sein können. Denn eins ist
      klar: Es gibt Menschen, die werden migrantisch gelesen und andere nicht.
      Es gibt Menschen, die erleben Diskriminierung und/oder Rassismus und
      andere nicht. All das geschieht auch in Weiterbildungsprozessen.
    </p>
    <p>Und das sind wir, Team Bildungswerk</p>
    <div class="image-container">
      <div class="display-item">
        <iframe [class.thumbnail]="thumbnail" [src]="safeSrc" frameborder="0" webkitallowfullscreen mozallowfullscreen
                allowfullscreen></iframe>
      </div>
      <div class="display-item">
        <img src="assets/images/aboutImg21.jpg" alt="about us logo"/>
      </div>
      <div class="display-item">
        <img src="assets/images/Teamfoto3.jpg" alt="about us logo"/>
      </div>
    </div>
  </div>
</div>
<!--
<div class="content-grid">
  <div class="content-child">

  </div>
  <div class="container content-child2">
    <div >
      <div >
        <iframe [class.thumbnail]="thumbnail" [src]="safeSrc" frameborder="0" webkitallowfullscreen mozallowfullscreen
          allowfullscreen></iframe>
      </div>
      <div >
        <img src="assets/images/aboutImg21.jpg" alt="about us logo" />
      </div>
      <div >
        <img src="assets/images/Teamfoto2.jpg" alt="about us logo" />
      </div>
    </div>
  </div>
</div> -->
